:host {
}

.stzh-vbz-majorticker {
  &__ghettobox {
    --stzh-base-invert-color: #{$colorBlack};
    --color: #{$colorBlack};
    --background-color: #{$colorCoral};
  }
}
